import axios from 'axios';
import authHeader from '../services/AuthHeader';
import {ENV_URL} from './Globals';
const IMAGES_URL = `${ENV_URL}/api/v1/images`;

class ImageDataService {

    //Get All Images
    getAllImages() {
        return axios.get(`${IMAGES_URL}`, {
            headers: authHeader()
        });
    };


//CREATE Image 
createImage(fileData) {
    return axios.post(`${IMAGES_URL}`,fileData,  {
        "Content-Type": "multipart/form-data",
        headers: authHeader()
    });
};


//Get Image by Id  
getImageData(imgId) {
    return axios.get(`${IMAGES_URL}/${imgId}`, {
        headers : authHeader()
    });
};


    //Update Image data 
    updateImageData(id,data) {
        return axios.put(`${IMAGES_URL}/${id}`, data , {
            headers : authHeader
        });
    };

  //DELETE  Image 
  deletImage(id) {
    return axios.delete(`${IMAGES_URL}/${id}`, {
        headers: authHeader()
    });
};



//get Image Picture 
downloadImagePic(id) {
    return axios.get(`${IMAGES_URL}/${id}/download`, {
        headers: authHeader()
    });  
};

//upload Image Picture
uploadImagePic(id) {
    return axios.post(`${IMAGES_URL}/${id}/upload`, {
        "file": "file",
        headers : authHeader()
    }); 
};

 
};

const imageDataService = new ImageDataService();
export default imageDataService;

